import React from 'react';
import { Container, Content, Title, Trigger, Wrapper } from './styled';
class MainSection extends React.PureComponent {

    render() {
        return (
            <Trigger>
                <Container noMargin={this.props.noMargin} noBottom={this.props.noBottom}>
                    <Title>{this.props.title}<Wrapper></Wrapper></Title>
                    <Content>
                        {this.props.children}
                    </Content>
                </Container>
            </Trigger>
        )
    }
}

export default MainSection;